export const PENDENTE = 'PENDENTE';
export const EXIGENCIA = 'CUMPRIMENTO_DE_EXIGENCIA';